// The pricing table's copy. Which plan the org is on comes from `/settings`;
// what a plan costs and the credits it grants come from billing
// (`useBillingPlans`). Nothing in the app is locked by plan yet.

import type { PlanId, PlanTier } from "@/shared/types";

export const PLANS: PlanTier[] = [
  {
    id: "free",
    name: "Free",
    tagline: "Try Definable and build your first agent.",
    features: [
      "1 custom agent",
      "Full access to Definable Agent",
      "Full access to Definable Code",
      "Limited apps from the 1,000+ catalog",
      "Limited in-house agents",
    ],
  },
  {
    id: "plus",
    name: "Plus",
    tagline: "For builders running agents every day.",
    features: [
      "Everything in Free",
      "Up to 10 custom agents",
      "Lite sandboxes for agent runs",
      "Private browser access",
      "500+ app integrations",
      "Most in-house agents",
    ],
  },
  {
    id: "pro",
    name: "Pro",
    tagline: "Full power for heavy, always-on automation.",
    features: [
      "Everything in Plus",
      "Unlimited custom agents",
      "Full sandboxes, including GPU",
      "Dedicated private browser fleet",
      "All 1,000+ app integrations",
      "Full in-house agent library",
      "Priority support & early access",
    ],
  },
];

export const planNamed = (id: PlanId): PlanTier => PLANS.find((p) => p.id === id)!; // PLANS is total over PlanId
